<template>
  <div>
    <quiz-form />
  </div>
</template>

<script>
import QuizForm from '../components/QuizForm.vue'

export default {
  components: {
    QuizForm,
  },
}
</script>
